import type { RouteLocationNormalized } from 'vue-router';
import { useNuxtApp } from '#app/nuxt';
import { showError } from '#app/composables/error';
import { useState } from '#app/composables/state';
import type { MenuDetailResponse } from '~~/server/api/kiwi_user/menus/detail';
import { useBreadcrumbs } from '~/composables/useBreadcrumbs';

export const MENU_DETAIL_STATE_KEY = 'public-article-menu-detail';

export async function menuDetailMiddleware(to: RouteLocationNormalized) {
  const params = to.params as { old_identifier: string };
  const isPreview = to.path.endsWith('/preview');
  const token = isPreview ? (to.query.token as string | undefined) : undefined;

  // NOTE: async関数内でawait後にcomposableを呼び出すと
  // Nuxtインスタンスのコンテキストが失われるため、事前に取得しておく
  const nuxtApp = useNuxtApp();
  const stateKey = `${MENU_DETAIL_STATE_KEY}-${params.old_identifier}`;
  const state = useState<MenuDetailResponse | null>(stateKey, () => null);
  const { setBreadcrumbs } = useBreadcrumbs();

  try {
    const data = await $fetch<MenuDetailResponse>(
      '/api/kiwi_user/menus/detail',
      {
        query: {
          old_identifier: params.old_identifier,
          ...(token && { token }),
        },
      },
    );

    state.value = data ?? null;

    if (!data) {
      return;
    }

    setBreadcrumbs([
      {
        to: '/public/article/recipe/top',
        text: 'ダイエットレシピ',
      },
      {
        to: '/public/article/menu',
        text: '献立',
      },
      {
        text: data.title,
      },
    ]);
  } catch (e) {
    state.value = null;
    await nuxtApp.runWithContext(() => showError(e as Error));
  }
}
